export default __webpack_public_path__ + "static/media/living-room.281cff42.png";